import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  hardwares: [],
  totalHardwares: 0,
}

export const mutations = {
  SET_HARDWARES(state, hardwares) {
    state.hardwares = hardwares
  },
  SET_TOTAL_HARDWARES(state, total) {
    state.totalHardwares = total
  },
}

export const actions = {
  fetchHardware3rdParties({ commit }, payload) {
    return ApiService.fetchHardware3rdParties(payload)
      .then((res) => {
        const { data, total } = res.data

        commit('SET_HARDWARES', data)
        commit('SET_TOTAL_HARDWARES', total)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchHardware3rdParty(_, payload) {
    return ApiService.fetchHardware3rdParty(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  addHardware3rdParty(_, payload) {
    return ApiService.addHardware3rdParty(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  editHardware3rdParty(_, payload) {
    return ApiService.editHardware3rdParty(payload).catch((error) => {
      throw error
    })
  },
  deleteHardware3rdParty(_, payload) {
    return ApiService.deleteHardware3rdParty(payload).catch((error) => {
      throw error
    })
  },
}

export const getters = {}
